import React from "react";
import { withRouter } from "react-router";
import { CreateStorySheet } from "./create-story";

/*
 * /Content/build/new (DS 2026-10-07; one-page layout 2026-10-08, mockup storyflow/NewStory): the Builder's start screen.
 * One page: a name, a few lines about it and a goal; pages, products, the offer, documents, screenshots and earlier
 * pieces are optional on the right. Creating the story opens /Content/build/:id on the Brief.
 */
class StoryNew extends React.Component {
  componentDidMount() {
    try {
      window.scrollTo(0, 0);
    } catch (e) {/* no window */}
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view content-view"
    }, /*#__PURE__*/React.createElement(CreateStorySheet, {
      onClose: () => this.props.history.push("/Content?tab=stories"),
      onCreated: (cid, o) => this.props.history.replace(`/Content/build/${cid}?goal=${encodeURIComponent(o && o.goal || "launch")}`)
    }));
  }
}
export default withRouter(StoryNew);